import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import gsap from 'gsap';

export default function Hero() {
  const codeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (codeRef.current) {
      gsap.from(codeRef.current.children, {
        opacity: 0,
        y: 20,
        duration: 0.5,
        stagger: 0.1,
        ease: 'power2.out'
      });
    }
  }, []);

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden bg-gradient-to-br from-gray-900 via-purple-900 to-indigo-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-6"
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold">
              <span className="bg-gradient-to-r from-purple-300 via-purple-200 to-indigo-300 bg-clip-text text-transparent font-extrabold">Trifusion</span>
              <span className="text-white"> Solutions</span>
              <br />
              <span className="text-2xl sm:text-3xl lg:text-4xl bg-gradient-to-r from-purple-200 via-indigo-200 to-purple-300 bg-clip-text text-transparent font-semibold">Innovative Software Development</span>
            </h1>
            <p className="text-lg text-gray-200 leading-relaxed">
              Leading innovative projects at Trifusion Solutions, delivering cutting-edge
              digital solutions that empower businesses in the evolving digital landscape.
            </p>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <a
                href="#projects"
                className="inline-flex items-center px-8 py-4 rounded-2xl text-white font-semibold bg-gradient-to-r from-purple-600 via-purple-700 to-indigo-600 hover:from-purple-700 hover:via-purple-800 hover:to-indigo-700 transition-all duration-300 shadow-lg hover:shadow-purple-500/25 transform hover:scale-105"
                style={{
                  boxShadow: '0 10px 40px rgba(147, 51, 234, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)'
                }}
              >
                View My Work
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </a>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="relative w-full"
          >
            {/* Coding Visual */}
            <div className="flex justify-center">
              <img 
                src="/coding-visual.svg" 
                alt="Trifusion Solutions Code Representation" 
                className="w-full max-w-md h-auto rounded-lg shadow-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}